export default __webpack_public_path__ + "static/media/Padron_Magnum2.8fdc27b1.jpg";